export enum ContractStatusEnum {
    Quote = 'Quote',
    Reservation = 'Reservation',
    Open = 'Open',
    Returned = 'Returned',
    Closed = 'Closed',
    Voided = 'Voided'
}
